import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useLoaderData, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { doFetch } from '../../utils/doFetch';
import { Welcome } from './Welcome';
import { WelcomeData } from './WelcomeData';

export const welcomeRouteLoader = async ({ request }: { request: any, params: any }) => {
  return doFetch(`welcome`, { signal: request.signal }, true, false);
}

/**
 * Route Component - Responsible for auth, router, data, etc.
 * @returns 
 */
export const WelcomeRoute = () => {
  const auth = useAuth();
  const location = useLocation();
  const data = useLoaderData() as WelcomeData;
  const signedIn = auth.isAuthenticated;
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  /**
   * Used as an intermediate redirect for the IdS to the Sign In page.
   * Since we require details about the client to access the Sign In page,
   * we can't redirect directly from an IdS page to the Sign In page.
   * This acts as a medium that allows for such a transaction to occur.
   */
  useEffect(() => {
    const checkSignInRedirect = async () => {
      if (searchParams.has("redirectToSignIn")) {
        if (!auth.isAuthenticated) {
          try {
            await auth.signinRedirect({ state: location, extraQueryParams: { timestamp: Date.now() + (10 * 60 * 1000) } });
          } catch (e: any) {
            alert("Error redirecting to sign in page. Please try again");
          }
        } else {
          searchParams.delete("redirectToSignIn");
          setSearchParams(searchParams);
        }
      }
    }
    checkSignInRedirect();
  }, []);

  const onNavigateToCurrentDispatch = async () => {
    if (signedIn) {
      navigate('/current-dispatch');
    } else {
      await auth.signinRedirect({
        state: { ...location, pathname: '/current-dispatch' },
        extraQueryParams: {
          timestamp: Date.now() + (10 * 60 * 1000)
        }
      });
    }
  }

  return <Welcome data={data} signedIn={signedIn} onNavigateToCurrentDispatch={onNavigateToCurrentDispatch} />;
}